<script setup lang="ts">
import AppLayout from '@/views/AppLayout.vue';
</script>
<template>
  <Suspense>
    <AppLayout />
  </Suspense>
</template>
<style lang="scss">
@forward 'tippy.js/dist/tippy.css';
</style>
